import React, { useState } from "react";
import clsx from "clsx";
import { ChevronDown } from "lucide-react";

const TailwindDropdown = ({ data, setActiveTab, selectedValue, className }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOptionSelect = (key) => {
    setActiveTab(key);
    setIsOpen(false);
  };
  return (
    <div className={clsx("relative inline-block text-left mt-4", className)}>
      <div>
        <button
          type="button"
          className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
          id="menu-button"
          aria-expanded={isOpen}
          aria-haspopup={isOpen}
          onClick={() => setIsOpen(!isOpen)}
        >
          {data.find((item) => item.key === selectedValue)?.value || "Select"}
          <ChevronDown size={20} aria-hidden={isOpen} />
        </button>
      </div>

      <div
        className={`absolute left-0 z-10 w-full origin-top-right top-full rounded-md bg-white focus:outline-none ${
          isOpen ? "border-[1px] border-t-0" : " ring-0 border-0"
        }`}
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="menu-button"
        tabIndex="-1"
      >
        <div
          className={clsx(
            `grid grid-rows-[0fr] transition-all ease-in-out duration-500`,
            isOpen ? "grid-rows-[1fr]" : ""
          )}
        >
          <div className="overflow-hidden">
            {data.map((item, index) => (
              <div
                key={index}
                className="py-1 hover:bg-gray-100 rounded"
                role="button"
                onClick={() => handleOptionSelect(item.key)}
              >
                <div
                  className="block px-4 py-2 text-sm text-gray-700"
                  role="menuitem"
                  id="menu-item-0"
                >
                  {item.value}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TailwindDropdown;
